
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { SystemAttributes } from '../attributes.model';
import { KanbanState } from '../../../../kanban.model';
import CellStore from '../../../../../../stores/CellStore';
import { vSelectInModalWithPopper } from '../../../../../../util';
import { Board } from '../../../../../backend/backendapi';
import { isBoardNotInSelectedAccount } from '../../../../kanban.util';

@Component({
  components: {
    vSelect,
  },
})
export default class CellAttributeEditor extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly attributes!: SystemAttributes;

  readonly cellStore = new CellStore();

  vSelectInModalWithPopper = vSelectInModalWithPopper;

  get cellId(): number | null {
    return this.attributes.cellId ?? null;
  }

  set cellId(cellId: number | null) {
    this.attributes.cellId = cellId ?? undefined;
  }

  get isBoardNotInSelectedAccount(): boolean {
    return isBoardNotInSelectedAccount(this.board, this.state.accounts);
  }

  mounted(): void {
    this.cellStore.loadIfAbsent();
  }

  @Watch('state.accounts')
  private onAccountChanged(): void {
    this.cellStore.reload();
  }
}
